var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleCaretRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49961 2.77474C7.65794 2.77474 7.81628 2.83307 7.94128 2.95807L13.3746 8.39141C14.2579 9.27474 14.2579 10.7247 13.3746 11.6081L7.94128 17.0414C7.69961 17.2831 7.29961 17.2831 7.05794 17.0414C6.81628 16.7997 6.81628 16.3997 7.05794 16.1581L12.4913 10.7247C12.8913 10.3247 12.8913 9.67474 12.4913 9.27474L7.05794 3.84141C6.81628 3.59974 6.81628 3.19974 7.05794 2.95807C7.18294 2.8414 7.34128 2.77474 7.49961 2.77474Z",
    fill: "#787486"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4996 2.77474C13.6579 2.77474 13.8163 2.83307 13.9413 2.95807L19.3746 8.39141C20.2579 9.27474 20.2579 10.7247 19.3746 11.6081L13.9413 17.0414C13.6996 17.2831 13.2996 17.2831 13.0579 17.0414C12.8163 16.7997 12.8163 16.3997 13.0579 16.1581L18.4913 10.7247C18.8913 10.3247 18.8913 9.67474 18.4913 9.27474L13.0579 3.84141C12.8163 3.59974 12.8163 3.19974 13.0579 2.95807C13.1829 2.8414 13.3413 2.77474 13.4996 2.77474Z",
    fill: "#787486"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCaretRight);
export default __webpack_public_path__ + "static/media/DoubleCaretRight.b0b141e7f2724902746c7d809f6a9d6d.svg";
export { ForwardRef as ReactComponent };